import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const marketingPath = {
  marketing: '/crm/marketing',

  // Target Group
  targetGroup: '/crm/marketing/target-group',

  // Partner Data Source
  partnerDataSource: '/crm/marketing/partner-data-source',

  // Event type
  eventType: '/crm/marketing/event-type',

  // Event
  event: '/crm/marketing/event',
  eventDetail: '/crm/marketing/event' + CRUDPathSegmentEn.DETAIL,
  eventDetailCode: '/crm/marketing/event' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  eventAdd: '/crm/marketing/event' + CRUDPathSegmentEn.ADD,
  eventEdit: '/crm/marketing/event' + CRUDPathSegmentEn.EDIT,

  // Criteria
  criteria: '/crm/marketing/criteria',

  // PartnerStage
  partnerStage: '/crm/marketing/partner-stage',

  // Visitors
  visitor: '/crm/marketing/visitor',
  visitorDetail: '/crm/marketing/visitor' + CRUDPathSegmentEn.DETAIL,
  visitorAdd: '/crm/marketing/visitor' + CRUDPathSegmentEn.ADD,
  visitorEdit: '/crm/marketing/visitor' + CRUDPathSegmentEn.EDIT,

  // Event report
  eventReport: '/crm/marketing/event-report'
};
export default marketingPath;
